export default function genererTranches() {
  return {
    montantBas: 0,
    montantHaut: 0,
    pourcentageReversement: 0,
  };
}
